import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/schemes/$id')({
  component: () => <Outlet />,
});
